export default __webpack_public_path__ + "static/media/gyroY.33e7ec4a.svg";